import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'

interface GeneralSectionProps {
    title: string
    children: ReactNode
}

const GeneralSection: FC<GeneralSectionProps> = ({ title, children }) => {
    return (
        <View style={styles.section}>
            <Typography.Heading variant="h5" style={styles.sectionTitle}>
                {title}
            </Typography.Heading>
            <View style={styles.sectionContent}>{children}</View>
        </View>
    )
}

const styles = StyleSheet.create({
    section: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        marginBottom: 16,
        borderBottomWidth: 1,
        borderBottomColor: ColorEnum.GRAY_200,
    },
    sectionTitle: {
        marginBottom: 16,
    },
    sectionContent: {
        gap: 8,
    },
})

export default GeneralSection
